module.exports = __webpack_public_path__ + "static/media/sega-controller.eeb5c6a7.png";